import { format, isValid, parseISO } from 'date-fns';
import { Share } from 'react-native';

import type { FamilyEvent } from '@/features/guardian/family-events';

export function buildEventShareMessage(event: FamilyEvent): string {
  const parsedDate = parseISO(event.date);
  const dateLabel = isValid(parsedDate) ? format(parsedDate, 'MMM d, yyyy') : event.date;

  return [
    event.eventName,
    event.playerName,
    `${dateLabel} · ${event.timeRangeLabel}`,
    event.venue.name,
  ].join(' · ');
}

/** Opens the platform share sheet. Dismissing it is intentionally a no-op. */
export function shareEvent(event: FamilyEvent): void {
  Share.share({ message: buildEventShareMessage(event) }).catch(() => {
    // The user dismissed the share sheet or sharing is unavailable.
  });
}
